import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
// let baseUrl = '/api/kj-gy-apartment'
// let baseUrl2 = '/api/kj-gy-apartment'

let api = {
  // 添加人员
  addPerson: `${baseUrl}/person/add`,

  // 删除人员
  deletePersonByCodes: `${baseUrl}/person/deleteByCodes`,

  // 获取人员详细信息
  getPersonByCode: `${baseUrl}/person/getByCode`,

  // 获取人员列表
  getPersonList: `${baseUrl}/person/getList`,

  // 获取人员分页
  getPersonPage: `${baseUrl}/person/getPage`,

  // 修改人员
  updatePerson: `${baseUrl}/person/update`,

  // 导出人员
  exportPerson: `${baseUrl}/person/export`,

  // 导入人员
  importPerson: `${baseUrl}/person/import`,

  // 获取承租列表
  getLeaseList: `${baseUrl}/lease/getList`,

  // 获取住户列表
  getEnterpriseList: `${baseUrl}/enterpriseInfo/getEnterpriseList`,

  // 获取卡类型列表
  getCardTypeList: `${baseUrl}/cardType/getList`,

  // 获取申请列表
  getBaklogPage: `${baseUrl2}/baklog/getBaklogPage`,

  // 申请人员详情
  getPersonBaklogByCode: `${baseUrl2}/baklog/getPersonBaklogByCode`,

  // 审批通过
  approveBaklogByCode: `${baseUrl2}/baklog/approveBaklogByCode`,

  // 审批驳回
  unApproveBaklogByCode: `${baseUrl2}/baklog/unApproveBaklogByCode`,

  // 对比记录
  getPersonPicUpdateRecordPage: `${baseUrl}/PersonPicUpdateRecord/getPage`,

  // 人员入住
  checkIn: `${baseUrl}/personStayRecord/toStay`,

  // 人员入住信息查询
  checkInDetail: `${baseUrl}/personStayRecord/getByCode/`,

  // 上传图片
  commonUploadImg: `${baseUrl}/common/uploadImg`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Person.js